<template>
  <vx-card title="Crear publicación">
    <div class="vx-row" v-if="post">
      <div class="vx-col sm:w-3/4 w-full mb-2">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-5">
            <!-- <pre>
                {{ typeof(post.favorito) }}
            </pre> -->
            <v-select
              id="favorito"
              :options="statusList"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="favorito"
            />
          </div>

          <div class="vx-col sm:w-1/2 w-full mb-5">
            <v-select
              :options="categorias"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="categoryBlog_id"
            />
          </div>

          <div class="vx-col w-full mb-5">
            <vs-input
              class="w-full"
              label-placeholder="Título"
              v-model="post.title"
            />
          </div>

          <div class="vx-col w-full mb-1">
            <froala :tag="'textarea'" :config="config" v-model="post.text"></froala>
          </div>

          <div class="vx-col w-full mb-0">
            <vs-textarea label="Resúmen a mostrar" v-model="post.description" />
          </div>

          <div class="vx-col w-full mb-5">
            <vs-input
              class="w-full"
              label-placeholder="Palabras clave"
              v-model="post.keywords"
            />
          </div>

          <div class="vx-col w-full mb-5 text-right">
              <vs-button color="primary" :disabled="loading" type="filled" @click="update()">{{ loading ? 'Actualizando' : 'Actualizar' }}</vs-button>
          </div>
        </div>
      </div>

      <div class="vx-col sm:w-1/4 w-full mb-2">
        <h2 class="medium-text mb-3">Imágenes</h2>

        <section class="text-center mt-5">
            <vx-card>
                <img :src="post.image.url" alt="" class="mw-100" v-if="post.image">

                <vs-button color="success" type="border" @click="setShowModalImages('destacada')">Destacada</vs-button>
            </vx-card>
        </section>

        <section class="text-center mt-5">
            <!-- <vx-card
                subtitle="Imagen destacada"
                subtitle-color="dark">
                <img src="https://www.mor.bo/wp-content/uploads/2020/08/duki.jpg" alt="" class="mw-100">
            </vx-card> -->

            <vx-card>
                <img :src="post.open_graph.url" alt="" class="mw-100" v-if="post.open_graph">

                <vs-button color="success" type="border" @click="setShowModalImages('open_graph')">Redes sociales</vs-button>
            </vx-card>
        </section>
      </div>
    </div>

    <modal-images @imagenSeleccionada="asignarImagen($event)"></modal-images>
  </vx-card>
</template>

<script>
import { mapState } from 'vuex'

import { froalaConfig } from '@/utilities/froalaConfig.js'

import GetAllCategoriasBlog from "@/apollo/queries/blog/categorias/GetAllCategoriasBlog.gql";
import GetBlogSlug from "@/apollo/queries/blog/GetBlogSlug.gql";
import UpdateBlog from '@/apollo/mutations/blog/UpdateBlog.gql'

// Components
import vSelect from "vue-select";
import ModalImages from '@/components/app/imagenes/ModalImages'
import VueFroala from "vue-froala-wysiwyg";

export default {
  data() {
    return {
      slug: this.$route.params.slug,
      config: froalaConfig,
      statusList: [
        { id: null, label: "Tipo de publicación" },
        { id: "0", label: "No destacar" },
        { id: "1", label: "Destacado" },
      ],
      categorias: [],
      loading: false,
      tipoImagen: null,
      post: null,
      categoryBlog_id: null,
      favorito: null
    };
  },
  mounted() {
    this.getCategories()

    this.getData();
  },
  components: {
    vSelect,
    ModalImages,
    VueFroala
  },
  methods: {
    getCategories() {
      this.$apollo
        .query({
          query: GetAllCategoriasBlog,
          fetchPolicy: "no-cache",
          variables: {
            estado: "",
          },
        })
        .then((res) => {
          let response = res.data.GetAllCategoriasBlog;

          // Se asigna la primera opción del select como null
          let firstItem = {
            id: null,
            label: "Seleccione una categoría",
          };

          this.categorias[0] = firstItem;

          response.forEach((item) => {
            let itemForSelect = {
              id: item.id,
              label: item.titleCategory,
            };

            this.categorias.push(itemForSelect);
          });

        });
    },
    getData() {
      this.$apollo
        .query({
          query: GetBlogSlug,
          fetchPolicy: "no-cache",
          variables: {
            slugTitle: this.slug,
          },
        })
        .then((res) => {
          let response = res.data.GetBlogSlug;

          this.post = res.data.GetBlogSlug

          this.categoryBlog_id = this.categorias.find(item => parseInt(item.id) === parseInt(this.post.Categoria.id));

          this.favorito = this.statusList.find(item => parseInt(item.id) === parseInt(this.post.favorito));
        });
    },
    setShowModalImages(type) {
      this.tipoImagen = type

      this.$store.dispatch('updateModalImagesStatus', true)
    },
    asignarImagen(data) {
      if(this.tipoImagen === 'destacada') {
        this.post.image = data
      } else if(this.tipoImagen === 'open_graph') {
        this.post.open_graph = data
      }
    },
    update() {
      this.loading = true
      
      this.$apollo.mutate({
        mutation: UpdateBlog,
        variables: {
          input: {
              id: this.post.id,
              title: this.post.title,
              text: this.post.text,
              keywords: this.post.keywords,
              image: this.post.image.id,
              open_graph: this.post.open_graph.id,
              description: this.post.description,
              categoryBlog_id: parseInt(this.categoryBlog_id.id)
          }
        }
      })
      .then(response => {
        this.loading = false

        this.$router.push('/blog')

        this.$vs.notify({
          title: 'Publicación actualizada',
          color: 'success',
          position: 'top-right'
        })
      })
    }
  },
  computed: {
    ...mapState(['showModalImages'])
  }
};
</script>

<style lang="scss" scoped>
</style>